import { type Charge, chargesEndpoints } from "../../../api";
import { useStrapiList } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

interface UseMyChargesProps {
  autoLoad?: boolean;
  [key: string]: unknown;
}

// autoLoad, sort, pagination, filters, populate
const useMyCharges = (props?: UseMyChargesProps) => {
  const {
    items: charges,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<Charge>({
    ...props,
    load: loadMyCharges,
    onLoadError: (e: unknown) => handleError(getErrorMessage(e, "Charges loading failed")),
  });

  return {
    charges,
    // setCharges,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadMyCharges = async (params: Record<string, unknown>) => {
  try {
    return await chargesEndpoints.getMyCharges(params);
  } catch (e: unknown) {
    handleError(getErrorMessage(e, "Charges loading failed"));
    return undefined;
  }
};

export default useMyCharges;
